import { Container } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import {useEffect, useState } from 'react';
import AdcSignInEntry from "./components/AdcSignInEntry";
import CorpSignInEntry from "./components/CorpSignInEntry";

const SignInRouterPage = () => {

  const [notice, setNotice] = useState<string | null>(null);

  useEffect(() => {
    const env = process.env.REACT_APP_DISPLAY_ENV_NAME;

    fetch('/notification.json')
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {

        let { default: { content } } = data;
        if (
          env &&
          data.overrides &&
          data.overrides[env] &&
          data.overrides[env].content &&
          data.overrides[env].content.trim() !== ''
        ) {
          content = data.overrides[env].content;
        }

        setNotice(content);
      })
      .catch((err) => {
        console.error('Notice loading failed:', err);
        setNotice('');
      });
  }, []);

  return (
    <Container component="main" fixed sx={{ my: 2, py: 1, maxWidth: 760 }}>
      <Grid container sx={{ my: 3, p: 2, display: "flex", alignItems: "stretch" }}>
        <Grid xs={12} sx={{ p: 1, display: "flex", alignItems: "stretch" }}>
          <b>This environment is for {process.env.REACT_APP_DISPLAY_ENV_NAME}</b>
        </Grid>
        <Grid xs={12} sm={6} sx={{ p: 1, display: "flex", alignItems: "stretch" }}>
          <CorpSignInEntry />
        </Grid>
        <Grid xs={12} sm={6} sx={{ p: 1, display: "flex", alignItems: "stretch" }}>
          <AdcSignInEntry />
        </Grid>
        <Grid xs={12} sx={{ p: 1, display: "flex", alignItems: "stretch" }}>
          <div >
          {notice ? <div dangerouslySetInnerHTML={{ __html: notice }} /> : null}
          </div>
        </Grid>
      </Grid>
    </Container>
  );
 
};

export default SignInRouterPage;